import { VDataTable } from 'vuetify/lib/components/VDataTable';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(VDataTable, {
    staticClass: "mt-4",
    attrs: {
      headers: _vm.headers,
      items: _vm.value,
      "items-per-page": -1,
      "hide-default-footer": "",
      "hide-default-header": "",
    },
    scopedSlots: _vm._u(
      [
        {
          key: `item.rating`,
          fn: function ({ item }) {
            return [
              _c("app-rating", {
                attrs: {
                  value: item.nota,
                  disabled: _vm.disabled,
                  tamanho: _vm.value.length > 1 ? 28 : 36,
                },
              }),
            ]
          },
        },
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }